import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import { ContentWrapper, Wrapper, Title, Subtitle, Button } from './ErrorPage.style';

class ErrorPage extends React.Component {
  static defaultProps = {
    copy: {
      coming_soon: {
        title: 'Coming Soon!',
        description: 'This page is currently under development.',
        label: 'Back To Homepage',
      },
      not_found: {
        title: '404 Page Not Found',
        description: 'Oops, it looks like the page you are looking for does not exist.',
        label: 'Back To Homepage',
      },
      not_available_in_region: {
        title: '404 Page Not Found',
        description: 'Oops, it looks like the page you are looking for is not avilable in your region.',
        label: 'Back To Homepage',
      },
    },
    title: 'Sorry',
    description: 'An error has occured. Please try again later.',
    label: 'Back To Homepage',
    url: undefined,
  };

  static propTypes = {
    copy: PropTypes.shape(),
    description: PropTypes.string,
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    locale: PropTypes.string.isRequired,
    setLocaleToGlobal: PropTypes.func.isRequired,
    title: PropTypes.string,
    url: PropTypes.string,
  };

  handleClick = () => {
    const { id, setLocaleToGlobal } = this.props;
    if (id === 'invalid_locale') setLocaleToGlobal();
  };

  render = () => {
    const { copy, id, locale, title, description, label, url } = this.props;

    const displayTitle = copy[id] ? copy[id].title : title;
    const displayDescription = copy[id] ? copy[id].description : description;
    const displayLabel = copy[id] ? copy[id].label : label;
    const displayUrl = copy[id] ? copy[id].url : url;

    return (
      <Wrapper>
        <ContentWrapper>
          <Title>{displayTitle}</Title>
          <Subtitle>{displayDescription}</Subtitle>
          <Button>
            <Link to={displayUrl || `/${locale}/`} href={displayUrl || `/${locale}/`} onClick={this.handleClick}>
              {displayLabel}
            </Link>
          </Button>
        </ContentWrapper>
      </Wrapper>
    );
  };
}

const mapState = state => ({
  copy: state.siteOptions.siteCopyErrors,
  locale: state.locale,
});

const mapDispatch = dispatch => ({
  setLocaleToGlobal: () => dispatch({ type: 'UPDATE_LOCALE', locale: 'en' }),
});

export default connect(mapState, mapDispatch)(ErrorPage);



// WEBPACK FOOTER //
// ./src/pages/ErrorPage/ErrorPage.js